import request from './handler'

const getList = async params => {
  const { data } = await request.get('/event', { params })
  return data
}
const getListParticipants = async params => {
  const { data } = await request.get('/event/detail', { params })
  return data
}
const create = form => request.post('/event', form)
const createParticipants = form => request.post('/event/detail', form)
const deleteEvent = id => request.delete(`/event?id=${id}`)
const deleteEventDetail = id => request.delete(`/event/detail?id=${id}`)
const getEventById = id => request.get(`/event?id=${id}`)
const updateEvent = (id, form) => request.put(`/event?id=${id}`, form)

export default {
  getList,
  getListParticipants,
  create,
  createParticipants,
  deleteEvent,
  deleteEventDetail,
  getEventById,
  updateEvent
}
